import { useContext, useEffect } from 'react';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import { px2DPIpx } from '../utils/pxrem';
import { getZIndex } from '../utils/z-index';
import { StickyTabsContext } from './context';
import './style.less';

export type StickyTabsStickyProps = {
  height: number;
} & CommonPropsWithChildren;

export const StickyTabsSticky = (props: StickyTabsStickyProps) => {
  const context = useContext(StickyTabsContext);
  const height = px2DPIpx(props.height);

  useEffect(() => {
    context?.onChangeTabsSticky({ height: parseFloat(px2DPIpx(props.height)) });
  }, [context, props.height]);

  return withNativeProps(
    props,
    <div className="v-sticky-tabs-sticky" style={{ height, zIndex: getZIndex() }} key="v-sticky-tabs-sticky">
      {props.children}
    </div>,
  );
};
